import React, { type ComponentType, forwardRef } from 'react';

import type { UIAnalyticsEvent } from '@atlaskit/analytics-next/src';
import { IconButton } from '@atlaskit/button/new';

import { BadgeContainer } from '../../../components/badge-container';

import NotificationsIcon from './temp-icons/notifications';

const NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';

type NotificationsProps = {
	/* The component to render as the badge */
	badge: ComponentType;

	/* Whether the notifications button is selected (highlights the button when the notifications menu is open) */
	isSelected?: boolean;

	/* The label for the notifications button */
	label?: string;

	/* The click handler for the notifications button (expected to open the notifications menu) */
	onClick?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

/**
 * __Notifications__
 *
 * The notifications button in the top navigation bar.
 */
export const Notifications = forwardRef<HTMLButtonElement, NotificationsProps>(
	({ badge, onClick, label, isSelected }, forwardedRef) => (
		<BadgeContainer id={NOTIFICATIONS_BADGE_ID} badge={badge} role="listitem">
			<IconButton
				icon={NotificationsIcon}
				label={label}
				onClick={onClick}
				appearance="subtle"
				isSelected={isSelected}
				ref={forwardedRef}
			/>
		</BadgeContainer>
	),
);
